module.exports = __webpack_public_path__ + "img/especialista3.a2b3e504.png";